import { observer } from 'mobx-react';
import { DynamicProduct } from '../dynamic-imports';
import wooCommerceStore from '@/stores/woocommerceStore';

const ProductModal = observer(() => {
  if (!wooCommerceStore.isProductModalOpen) {
    return null;
  }

  const product = wooCommerceStore.selectedProduct;

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => wooCommerceStore.hideProductModal()} />
      <DynamicProduct view="modal" product={product} />
    </>
  );
});

export default ProductModal;
